export default {
  navigationBarTitleText: '关于我们'
}
